// The code editor the five code widgets sit on top of.
//
// `widgets/{html,style,script,markdown,sql}` have imported this module since
// they were ported, and until now it did not exist — so all five threw at
// import time and none could be registered, which is why a Section's markup was
// a textarea and why `widget: "html"` on a schema field took down every screen
// that touched the type (docs/pagews.md, P132).
//
// WHY CODEMIRROR 6 AND NOT THE 5 THE ARCHIVED PROJECT USED
//
// CodeMirror 5 is end-of-life. The port kept its INTERFACE — the five widgets
// pass `mode`, `value`, `onChange` and `layout` — and replaced what is behind
// it: `mode` strings map to a v6 language extension rather than to a
// `codemirror/mode/*` side-effect import. See ./editor. Since form-schema
// 1.5.0 they also pass `labelId` and `describedById`, the ids of the field's
// label and description, which the editor puts on its editable element.
//
// WHY IT IS LAZY
//
// CodeMirror plus the five language grammars is 189 kB gzip — half again on top
// of a main bundle that webpack already calls too big, for something two
// screens of one app use. Imported statically it lands in `main.js` and every
// visitor pays it to look at a list of sites. Behind `React.lazy` it is a chunk
// fetched when a form first renders a code field, and the main bundle is
// unchanged.
//
// The fallback is sized rather than a spinner because a control that reserves
// no space makes the form jump when it arrives — but with the warm below it is
// only ever seen by a form rendered in the first moments after boot.
//
// Jest evaluates the warm below as soon as anything imports this module, so a
// suite that so much as touches the widget registry loads ./editor — which is
// why `@marijn` is exempted from CRA's transformIgnorePatterns in
// craco.config.js. @codemirror/state reaches a dependency whose `main` is ESM
// and whose CJS build is reachable only through an `exports` condition that
// this jest does not read.
import React from "react";

const load = () => import("./editor");

const Editor = React.lazy(load);

// Fetched as soon as anything imports this module — which is app boot, because
// the widget registry does — rather than when a form first renders a code field.
//
// WHY WARMING IS NOT OPTIONAL
//
// `React.lazy` resolves synchronously once its promise has settled, so a warmed
// editor mounts in the SAME COMMIT as the rest of the form. Cold, it suspends,
// and the field arrives one or more frames later.
//
// That delay is not cosmetic. A re-render of a form destroys any modal open
// over it — P143, which predates this file and reproduces on `dev` — so every
// millisecond a field spends not being there is another chance for a background
// query to answer and take the modal with it. A cold chunk lost that race every
// time; warmed, it stops being a factor. It was not enough on its own to make
// the page element editor safe, which is why that one screen opts out of these
// widgets entirely (see its route), but it is why every other screen can use
// them.
//
// What warming does NOT undo is the reason for splitting: `main.js` is parsed
// and executed before anything renders, and this is 189 kB that is not in it.
load();

export const Control = (props) => {
  const { layout = {} } = props;
  const height = layout.height || "18rem";

  return (
    <React.Suspense
      fallback={
        <div
          className="border rounded bg-light"
          style={{ width: layout.width || "100%", height }}
        />
      }
    >
      <Editor {...props} />
    </React.Suspense>
  );
};
